import React, { useEffect } from 'react';
import MediaUploader from './components/MediaUploader';
import './App.css'
import { AnalyticsTracker } from './Utils/analytics-tracker';
import { ANALYTICS_SOURCES } from './Utils/constant';
import { getAnalyticsData } from './Utils/analytics-payload';

function App() {
  useEffect(() => {
    AnalyticsTracker.initializeAnalytics(true, getAnalyticsData);
    AnalyticsTracker.sendAnalyticsEvent(ANALYTICS_SOURCES.TRY_ON, 'PAGE_VIEW');
  }, []);
  
  return (
      <MediaUploader />
  );
}

export default App;
